module.exports = __webpack_public_path__ + "static/media/g-hero-small.ed788a2e.png";